import { render, staticRenderFns } from "./change_rule.vue?vue&type=template&id=8626e972&scoped=true&"
import script from "./change_rule.vue?vue&type=script&lang=js&"
export * from "./change_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8626e972",
  null
  
)

export default component.exports